import { MainContent } from '@/deskUiSkeletons/Page/MainContent'
import { legacyContractAttrs, legacyHookAttrs } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { selectMainHeadingText, selectMainState } from '@/msgdeskRuntime/state'
import { useSubsStore } from '@/state/MsgTreeProvider'
import { ForumFoldSubsButton } from './panels/ForumControls'

export function ForumMainTopic() {
  const { state } = useSubsStore()
  const main = selectMainState(state)
  const title = selectMainHeadingText(state) || 'Forum topic'
  const author = main.author || main.nameKey || 'Forum member'

  return (
    <article {...legacyHookAttrs('main.root', 'md-forum-topic mb-4 border border-[#006699] bg-[#dfe6ef] font-[Verdana,Arial,Helvetica,sans-serif] text-[11px] text-black')}>
      <header {...legacyHookAttrs('main.header', 'md-forum-topic__head flex items-center justify-between gap-3 bg-[#006699] px-2 py-1 text-white')}>
        <div className="min-w-0">
          <div {...legacyHookAttrs('main.avatarFrame', 'hidden')} hidden aria-hidden="true"><img {...legacyContractAttrs('main.avatarImage')} alt="" /></div>
          <span {...legacyHookAttrs('main.nameKeySign', 'hidden')} hidden aria-hidden="true">@</span>
          <span {...legacyHookAttrs('main.authorFrame', 'hidden')} hidden aria-hidden="true">{author}</span>
          <div {...legacyHookAttrs('main.emailRegion', 'hidden')} hidden aria-hidden="true" />
          <div {...legacyHookAttrs('main.subjectRegion', 'min-w-0')}>
            <div {...legacyHookAttrs('main.subjectLine', 'min-w-0')}>
              <h1 {...legacyHookAttrs('main.subjectText', 'truncate text-[11px] font-bold')}>{title}</h1>
            </div>
            <div {...legacyHookAttrs('main.lineClear', 'hidden')} hidden aria-hidden="true" />
          </div>
        </div>
        <span {...legacyHookAttrs('main.datetime', 'flex-none whitespace-nowrap text-[10px]')}>{main.datetime || ''}</span>
      </header>
      <div {...legacyHookAttrs('main.quad', 'md-forum-topic__body grid grid-cols-[140px_minmax(0,1fr)] max-[640px]:block')}>
        <aside className="border-r border-[#006699] bg-[#eef3f8] p-3 text-center max-[640px]:border-b max-[640px]:border-r-0">
          <div className="font-bold text-[#006699]">{author}</div>
          <div className="mt-2 text-[10px]">Topic author</div>
        </aside>
        <div {...legacyHookAttrs('main.body', 'relative min-w-0 p-3')}>
          <div className="mb-2 flex justify-end"><ForumFoldSubsButton kind="msg" label="Fold topic" /></div>
          <div {...legacyHookAttrs('main.iframe', 'min-h-20 break-words leading-[1.45] [&_a]:text-[#006699] [&_img]:max-w-full')}>
            <MainContent />
          </div>
        </div>
        <div {...legacyHookAttrs('main.editMount', 'hidden')} hidden aria-hidden="true" />
      </div>
    </article>
  )
}
